const videoWithText = document?.querySelectorAll(".video-with-text");
videoWithText?.forEach((item) => {
  const imageSection = item?.querySelector(".left-section > img");
  const svg = item?.querySelector(".left-section .play-btn");
  const video = item?.querySelector(".left-section video");
  video.addEventListener("click", function () {
    if (imageSection) {
      imageSection.style.display = "none";
    }
    if (svg) {
      svg.style.display = "none";
    }
  });
});
